import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { Divider, Drawer, Grid, List, ListItem, ListItemIcon, ListItemText, Toolbar } from '@mui/material'
import { toggleMobileMenuVisible } from 'state/ui'
import Link from 'components/generic/links'

const drawerWidth = 240

const DrawerLayout = ({ tabs }) => {
  const isMobileMenuVisible = useSelector(state => state.ui.isMobileMenuVisible)
  const dispatch = useDispatch()

  const handleDrawerToggle = () => {
    dispatch(toggleMobileMenuVisible())
  }

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List>
        {tabs.map(tab => (
          <Link key={tab.route} to={tab.route}>
            <ListItem button onClick={handleDrawerToggle}>
              <ListItemIcon>{tab.icon}</ListItemIcon>
              <ListItemText primary={tab.title} />
            </ListItem>
          </Link>
        ))}
      </List>
    </div>
  )

  return (
    <>
      <Drawer
        variant="temporary"
        open={isMobileMenuVisible}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {drawer}
      </Drawer>

      <Grid item flexGrow={1}>
        <Outlet />
      </Grid>
    </>
  )
}

DrawerLayout.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      title: PropTypes.string.isRequired,
      route: PropTypes.string.isRequired,
      matchPath: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

DrawerLayout.defaultProps = {}

export default DrawerLayout
